// Utilitários de grade temporal compartilhados entre AbaGantt (ProjetoDetalhe)
// e AbaLinhaDoTempo (Workload) — SPEC-UX §10.3 "mesma função... alimenta
// as duas telas" (aplicado aqui à camada visual, não só a carga.ts).

export function diasEntre(dataA: string, dataB: string): number {
  const a = new Date(dataA + 'T00:00:00Z').getTime();
  const b = new Date(dataB + 'T00:00:00Z').getTime();
  return Math.round((b - a) / 86_400_000);
}

export function somarDias(data: string, dias: number): string {
  const d = new Date(data + 'T00:00:00Z');
  d.setUTCDate(d.getUTCDate() + dias);
  return d.toISOString().slice(0, 10);
}

export function ehFimDeSemana(dataInicio: string, offsetDias: number): boolean {
  const data = new Date(dataInicio + 'T00:00:00Z');
  data.setUTCDate(data.getUTCDate() + offsetDias);
  const diaSemana = data.getUTCDay();
  return diaSemana === 0 || diaSemana === 6;
}

export function formatarDiaEixo(dataInicio: string, offsetDias: number): string {
  const data = somarDias(dataInicio, offsetDias);
  const [, mes, dia] = data.split('-');
  return `${dia}/${mes}`;
}
